/* global google */

export default function logoutProcess() {
	google.accounts.id.disableAutoSelect()
	localStorage.removeItem('token')
	localStorage.removeItem('email')
	window.location = '/'
}
